import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=e9d98d0a&"
import script from "./ContactForm.vue?vue&type=script&lang=js&"
export * from "./ContactForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9d98d0a')) {
      api.createRecord('e9d98d0a', component.options)
    } else {
      api.reload('e9d98d0a', component.options)
    }
    module.hot.accept("./ContactForm.vue?vue&type=template&id=e9d98d0a&", function () {
      api.rerender('e9d98d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contacts/ContactForm.vue"
export default component.exports